import apiPath from '../../../config/api';

const StockSalesPath = {
    title: "Permata - Persediaan dan Penjualan",
    basePath: "/permata/stok-sales",
    base: apiPath.retailStockSales,
    stockSalesSum: apiPath.retailStockSalesSum,
    stockSalesExcel: apiPath.retailStockSalesExcel,
    stockSalesFind: apiPath.retailStockSalesFind
}

export default StockSalesPath;
